import { render, staticRenderFns } from "./ViewShowProfilesButton.vue?vue&type=template&id=5c5e70f4&scoped=true"
import script from "./ViewShowProfilesButton.vue?vue&type=script&lang=js"
export * from "./ViewShowProfilesButton.vue?vue&type=script&lang=js"
import style0 from "./ViewShowProfilesButton.vue?vue&type=style&index=0&id=5c5e70f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e70f4",
  null
  
)

export default component.exports